export const getStoredState = (key: string) => {
  const storedState = localStorage.getItem(key)
  if (!storedState) return null

  try {
    return JSON.parse(storedState)
  } catch (e) {
    return null
  }
}

export const storeState = (key: string, state: any) =>
  localStorage.setItem(key, JSON.stringify(state))

export const clearState = (key?: string) =>
  key ? localStorage.removeItem(key) : localStorage.clear()
